import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Helmet from 'react-helmet';
import { SWRConfig } from 'swr';
import { Toaster } from 'react-hot-toast';

import routes from './configs/routes';

import './App.css';

const LoginLayout = lazy(() => import('common/layouts/login'));

function App() {
  return (
    <BrowserRouter>
      <Helmet htmlAttributes={{ lang: 'fa' }} />
      <SWRConfig
        value={{
          errorRetryCount: 1,
        }}
      >
        <div id="main">
          <Suspense>
            <Routes>
              <Route path={'/'} element={<LoginLayout />} index />
              <Route path={'login'} element={<LoginLayout />} index />
              {Object.entries(routes).map(([key, route]) => (
                <Route
                  key={key}
                  path={'*'}
                  element={<route.layout />}
                  index={route?.index}
                />
              ))}
            </Routes>
          </Suspense>
        </div>
      </SWRConfig>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
